import { inject } from '@angular/core';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { ManagementService } from '@thiememeulenhoff/ng-api-gateway';
import { Method } from '@thiememeulenhoff/types';
import { firstValueFrom } from 'rxjs';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

const methodsConfig = entityConfig({
  entity: {} as Method,
  collection: 'methods',
  selectId: (method: Method) => method.slug,
});

export const ManagementMethodsStore = signalStore(
  { providedIn: 'root' },
  withEntities(methodsConfig),
  withRequestStatus(),
  withMethods((store, managementService = inject(ManagementService)) => ({
    async fetchMethods(): Promise<void> {
      patchState(store, { requestStatus: 'loading' });

      try {
        const methods = await firstValueFrom(
          managementService.fetchManagementMethods(),
        );

        const displayableMethods = methods.filter(({ name, slug }) =>
          Boolean(name?.trim() && slug?.trim()),
        );

        patchState(store, setAllEntities(displayableMethods, methodsConfig), {
          requestStatus: 'success',
        });
      } catch (error) {
        patchState(store, {
          requestStatus: toRequestError(error, 'Failed to fetch methods'),
        });
      }
    },
  })),
);
